import Layout from './common/Layout';
import Error from './common/Error';
import { useTranslation } from "react-i18next";
import Back from './common/Back';
import { useSelector } from "react-redux";
import BuyerForm from './BuyerForm';
import { isEmpty } from '../Util';

const BuyerSearch = () => {

    const { t } = useTranslation();
    const shouldSearchBuyer = useSelector((state) => state.Reducer.shouldSearchBuyer)
    const isTransactionProcessing = useSelector((state) => state.Reducer.isTransactionProcessing)   
    const error = useSelector((state) => state.Reducer.error) 
   
    return (
    <Layout>
        { shouldSearchBuyer && isTransactionProcessing && isEmpty(error) &&
            <BuyerForm/>
        }
        <Error renderer={!shouldSearchBuyer || !isTransactionProcessing} message={t('home.error.text')}/>
        <Back renderer={true} message={t('app.back.link')} />
    </Layout>
    );
};  

export default BuyerSearch;